import React, { useContext,useEffect } from 'react'
import {dataContext,toText,localestr,load,itemToText,typeToText,inputFrom,strPeriod,filter_fn} from '../utils.js'
import UniTable from '../cmp/UniTable.js'
import FilterForm from '../cmp/FilterForm.js' //+
//import RangeForm from '../cmp/RangeForm'
import Menu from '../cmp/menu.js'
import icon from '../icons.svg'

function DocRejectList({data=undefined,actions,choice=false}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    const getGlData=actions.getGlData

    const context=useContext(dataContext)
    let table=undefined
    if(wndData) table=wndData.table
    const getSettings=context.getSettings
    const setSettings=context.setSettings
    const load_data=context.loaddata
    const msg=context.msg
    const inputRange=context.inputRange
    const usersettings=getSettings()
    const inputCols=context.inputCols
    const selGoodType=context.data['selGoodType']
    const urAdmin=parseInt((context.user||{}).urAdmin||0)
    const isAuthor = (context.user || {}).id===(wndData.author || {}).id
    let posted = !urAdmin
    let minDate = (new Date()).toISOString()
    if((context.user || {}).rights?.urDocs3Edit){
        let d = new Date()
        d.setDate(d.getDate() - 3)
        if(minDate > d.toISOString()) minDate = d.toISOString()
    }
    if((context.user || {}).rights?.urDocs7Edit){
        let d = new Date()
        d.setDate(d.getDate() - 7)
        if(minDate > d.toISOString()) minDate = d.toISOString()
    }
    if((context.user || {}).rights?.urDocsREdit){
        if(context.last_rev && context.last_rev < minDate) minDate = context.last_rev
    }
    if(urAdmin){
        let d = new Date()
        d.setDate(d.getDate() - 1095) // 3 роки взад
        if(minDate > d.toISOString()) minDate = d.toISOString()
    }
    if(posted){
        if(wndData.date && wndData.date > minDate){
        if(isAuthor && (context.user || {}).rights?.urDocsOEdit) posted=false  // автор може редагувати свої документи, але врахувати останню ревізію чи дату
        if((context.user || {}).rights?.urDocsSEdit) posted=false  // автор може редагувати чужі документи, але врахувати останню ревізію чи дату
        }
    }

    let from=new Date()
    from.setHours(0,0,0,0)
    let to=new Date()
    to.setHours(23,59,59,999)
    if (usersettings){
        if (usersettings.jrnRejectList){
            if (usersettings.jrnRejectList.from) from=usersettings.jrnRejectList.from
            if (usersettings.jrnRejectList.to && to-usersettings.jrnRejectList.to>172860000) to=usersettings.jrnRejectList.to
        }
    }
    //console.log(from)
    if (wndData.from) from=wndData.from
    if (wndData.to) to=wndData.to
    if (typeof from==='string') from=new Date(from)
    if (typeof to==='string') to=new Date(to)
    if(wndData&&wndData.currentCol&&wndData.currentCol.date){
        let cur_from=wndData.currentCol.date
        if (typeof cur_from==='string') cur_from=new Date(cur_from)
        if(cur_from.getTime()<from.getTime()) from=cur_from
    }
    //console.log(from)

    const cols=[
        {caption:'icon',minWidth:'24',dataId:'docum',sortable:false},
        {caption:' №',minWidth:'40',maxWidth:'65',dataId:'id',sortable:true},
        {caption:localestr('Дата'),minWidth:'75',maxWidth:'150',dataId:'date',sortable:true},
        {caption:localestr('Контрагент'),minWidth:'95',dataId:'counterpartie',sortable:true},
        {caption:localestr('Сума'),minWidth:'60',maxWidth:'75',dataId:'sum',sortable:true},
        {caption:localestr('Причина'),minWidth:'75',dataId:'reason',sortable:true},
        {caption:localestr('Підрозділ'),minWidth:'75',dataId:'department',sortable:true},
        {caption:localestr('Автор'),minWidth:'75',dataId:'author',sortable:true},
        {caption:localestr('Примітка'),minWidth:'75',dataId:'note',sortable:true}
    ]

    if(usersettings.DocRejectList&&usersettings.DocRejectList.cols){
        for(let i=0;i<usersettings.DocRejectList.cols.length;i++){
            const idx=cols.findIndex(el=>el.dataId===usersettings.DocRejectList.cols[i])
            if(idx!==-1) cols[idx].hiden=true
        }
    }

    const filterData=[ //+
        {caption:' №',minWidth:'40',dataId:'id',typeVal:'text'},
        {caption:localestr('Дата'),dataId:'date',typeVal:'datetime'},
        {caption:localestr('Контрагент'),dataId:'counterpartie',typeVal:'catCounterparties'},
        {caption:localestr('Сума'),dataId:'sum',typeVal:'number'},
        {caption:localestr('Підрозділ'),dataId:'department',typeVal:'catDepartments'},
        {caption:localestr('Причина'),dataId:'reason',typeVal:'text'},
        {caption:localestr('Автор'),dataId:'author',typeVal:'catUsers'},
        {caption:localestr('Видалені'),dataId:'marked',typeVal:'selYN'},
        {caption:localestr('Проведені'),dataId:'posted',typeVal:'selYN'},
        {caption:localestr('Примітка'),dataId:'note',typeVal:'text'}
    ]

    const setFilter=(id,val,type)=>{
        let filter=[...(wndData.filter||[])]
        const idx=filter.findIndex(el=>el.dataId===id)
        if(idx!==-1){
            if(!val) filter.splice(idx,1)
            else filter[idx].value=val
        } else if(val) filter.push({dataId:id, compare:'lk', value:val, typeVal:type})
        if (!filter.length) filter=undefined
        setWndData({...wndData,filter,currentCol:undefined})
        setGlData({needFocus:1})
        tblPos(0)
    }

    const showHideFilter=()=>{
        const showAFilter=!wndData.showAFilter
        if(!showAFilter) setWndData({...wndData,filter:undefined,showAFilter})
        else setWndData({...wndData,showAFilter})
    }

    const loadData=(d)=>{
        if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            setWndData({...wndData,table:d.data})
        } else {
            wndData=actions.getWndData()
            if (wndData.from) from=wndData.from
            if (wndData.to) to=wndData.to
            load('action=jrnReject&data='+JSON.stringify({from,to}),(dt)=>{loadData(dt)})
        }

    }

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        if (table) list=table.map((item)=>{
            const newItem={id:item.id,marked:item.marked,posted:item.posted,date:item.date,reason:item.reason,counterpartie:{id:item.counterpartie_id,name:item.counterpartie,pid:item.pid},department:{id:item.department_id,name:item.department},sum:item.sum,author:{id:item.author_id,name:item.author},note:item.note}
            if(item.docs) newItem.docs=item.docs
            newItem.title=null
            if(item.tbl){
                newItem.tbl=item.tbl
                item.tbl.forEach(el=>{
                    if(newItem.title) newItem.title+="\n"+el.good_id+' '+el.good+' :  '+el.qtt+(selGoodType.find(x => x.value === item.type)||{name:localestr('шт')}).name+' : '+el.amount
                    else newItem.title=el.good_id+' '+el.good+' :  '+el.qtt+(selGoodType.find(x => x.value === item.type)||{name:localestr('шт')}).name+' : '+el.amount
                })
            }
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol({...newItem})
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else if(col==='date') {
                vala=(a[col])
                valb=(b[col])
            } else if(col.substring(0,4)==='sum_') {
                vala=parseFloat(a[col]||0)
                valb=parseFloat(b[col]||0)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }
    
    const setHidenCols=(data)=>{
        if(data){
            const new_data=data.filter(el=>el.hiden).map(el=>el.dataId)
            setSettings({DocRejectList:{cols:new_data}})
        } else {
            inputCols(cols,setHidenCols)
        }
    }

    const newItem=()=>{
        tabNew('docReject_edit',localestr('Повернення')+' *',{date:(new Date()).toISOString().substring(0, 19)+'Z',author:context.user,edit:true,update:after_save})
    }

    const editItem=(d)=>{
            if (!d && typeof wndData.currentCol === 'object') load('action=docReject&data='+wndData.currentCol['id'],editItem)
            else if (d) {
                const status=d.status
                if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
                if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
                tabNew('docReject_edit',localestr('Повернення')+' №'+toText(d.data['id']),{...d.data,table:d.table,update:after_save})
        }
    }
            
    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else editItem()
        }
    }

    const copyItem=(d)=>{
        if (!d && typeof wndData.currentCol === 'object')  load('action=docReject&data='+wndData.currentCol['id'],copyItem)
        else if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            let item={...d.data,currentCol:{id:0},edit:true,update:after_save}
            delete item.id
            item.date=(new Date()).toISOString().substring(0, 19)+'Z'
            item.author=context.user
            item.posted=0
            item.marked=0
            item.table=d.table.map(el=>{return{...el,edit:true,id:undefined}})
            tabNew('docReject_edit',localestr('Повернення')+' *',item)
        }
    }

    const removeItem=(d)=>{
        if(!urAdmin){
            msg(localestr('Не достатньо прав для позначення на видалення'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if (!d && typeof wndData.currentCol === 'object') {
            let newData={id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='0'?'1':'0')}
            load('action=remReject&data='+JSON.stringify(newData),removeItem)
        }
        else if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            let item={...d.data}
            let newData={...wndData}
            if (newData.currentCol) if(newData.currentCol.id===item.id) {newData.currentCol.marked=item.marked;newData.currentCol.posted='0'}
            newData.currentCol=item
            if (newData.list) newData.list.forEach(el => {
                if(el.id===item.id) {el.marked=item.marked;el.posted='0'}
            })
            if (newData.table) newData.table.forEach(el => {
                if(el.id===item.id) {el.marked=item.marked;el.posted='0'}
            })
            setWndData(newData)
        }
    }

    const postItem=(d)=>{
        if (!d && typeof wndData.currentCol === 'object') {
            if(posted){
                msg(localestr('Не достатньо прав для проведення документа'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
                return
            }
            let newData={id:wndData.currentCol.id}
            load_data('action=postReject&data='+JSON.stringify(newData),undefined,postItem)
        }
        else if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            let item={...d.data}
            let newData={...wndData}
            if (newData.currentCol) if(newData.currentCol.id===item.id) newData.currentCol.posted='1'
            //newData.currentCol=item
            if (newData.list) newData.list.forEach(el => {
                if(el.id===item.id) el.posted='1'
            })
            if (newData.table) newData.table.forEach(el => {
                if(el.id===item.id) el.posted='1'
            })
            setWndData(newData)
        }
    }
    
    const unpostItem=(d)=>{
        if(!urAdmin){
            msg(localestr('Не достатньо прав для відміни проведення'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if (!d && typeof wndData.currentCol === 'object') {
            let newData={id:wndData.currentCol.id}
            load('action=unpostReject&data='+JSON.stringify(newData),unpostItem)
        }
        else if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            let item={...d.data}
            let newData={...wndData}
            if (newData.currentCol) if(newData.currentCol.id===item.id) newData.currentCol.posted='0'
            //newData.currentCol=item
            if (newData.list) newData.list.forEach(el => {
                if(el.id===item.id) el.posted='0'
            })
            if (newData.table) newData.table.forEach(el => {
                if(el.id===item.id) el.posted='0'
            })
            setWndData(newData)
        }
    }

    const inputItem=(to,d)=>{
        if (!d && typeof wndData.currentCol === 'object')  load('action=docReject&data='+wndData.currentCol['id'],d=>inputItem(to,d))
        else if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            let item=inputFrom('docReject',to,{...d.data,table:d.table,author:context.user,edit:true})
            tabNew(to+'_edit',typeToText(to)+' *',item)
        }
    }
    
    const setCol=(currentCol)=>{
        //const list=wndData.list
        //const sorting=wndData.sorting
        setWndData({...wndData,currentCol})
        setGlData({needFocus:0})
    }

    const filter=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        if(showFilter || fltr===undefined) setWndData({...wndData,showFilter,filter})
        else{
            setWndData({...wndData,showFilter,filter,currentCol:undefined})
            setGlData({needFocus:1})
            tblPos(0)
        }
    }

    const range=(frm,to_)=>{
        //let showRange=!wndData.showRange
        let froml=from
        let tol=to
        if (frm!==undefined) froml=frm
        if (to_!==undefined) tol=to_
        let Datal=table
        if (froml!==from || tol!==to) {
            //loadData()
            Datal=undefined
        }
        const new_wndData={...wndData,from:froml,to:tol,table:Datal}
        if(new_wndData?.currentCol?.date){
            let cur_from=new_wndData.currentCol.date
            if (typeof cur_from==='string') cur_from=new Date(cur_from)
            if(cur_from.getTime()<new_wndData.from.getTime()) new_wndData.currentCol=undefined
            if(cur_from.getTime()>new_wndData.to.getTime()) new_wndData.currentCol=undefined
        }
        //setWndData({...wndData,from:froml,to:tol,table:Datal})
        setWndData(new_wndData)
        setSettings({jrnRejectList:{from:froml,to:tol}})
    }

    const after_save=(d)=>{
        const currentCol={}
        currentCol.id=''+d.id
        setTimeout(()=>{setWndData({...wndData,currentCol});setGlData({needFocus:0})},10)
        loadData()
    }

    const tick=()=>{
        wndData=actions.getWndData()
        if (wndData.showRange) return
        loadData()
    }

    const clrInfo=(newData)=>{
        const act=newData.status
        if (act==='error') {msg(newData.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
        const data=newData.data
        if (act==='clrOk'){
            let cont_del=[]
            let cont_no=[]
            data.forEach(el=>{
                cont_del.push(<div style={{padding:'0 0 0 10px'}} key={'d'+cont_del.length}>{itemToText({...el,type:'docReject'})}</div>)
              })
              let cont=null
              if(cont_del.length>0&&cont_no.length>0) cont=<div><div style={{fontWeight:'bold'}}>{localestr('Видалено')+' '+cont_del.length}</div><div>{cont_del}</div><div style={{fontWeight:'bold'}}>{localestr('Не видалено')+' '+cont_no.length}</div><div>{cont_no}</div></div>
              else if(cont_no.length>0) cont=<div><div style={{fontWeight:'bold'}}>{localestr('Не видалено')+' '+cont_no.length}</div><div>{cont_no}</div></div>
              else if(cont_del.length>0) cont=<div><div style={{fontWeight:'bold'}}>{localestr('Видалено')+' '+cont_del.length}</div><ul>{cont_del}</ul></div>
              msg(cont,localestr('Інформація'),[{caption:'OK',action:()=>{}}])
              loadData()
        }
    }

    const clrDocument=(noQuestions)=>{
        if(noQuestions){
            load('action=clrReject',clrInfo)
        }
        else msg(localestr('Буде видалено позначені документи без\nможливості відновлення! Продовжити?'),localestr('Попередження'),[{caption:'OK',action:()=>{clrDocument(true)}},{caption:localestr('Відміна'),action:()=>{}}])
    }

    const objHistory=()=>{
        if (typeof wndData.currentCol === 'object') {
            const item={...wndData.table.find(el=>el.id===wndData.currentCol.id),type:'docReject'}
            tabNew('repObjHistory',localestr('Історія змін')+' '+itemToText(item),{object:item},true)
        }
    }
        
    const objEntries=()=>{
        if (typeof wndData.currentCol === 'object') {
            const item={...wndData.table.find(el=>el.id===wndData.currentCol.id),type:'docReject'}
            tabNew('repObjEntries',localestr('Проводки')+' '+itemToText(item),{object:item},true)
        }
    }

    const doc_print=(d)=>{
        if (!d && typeof wndData.currentCol === 'object')  load('action=docReject&data='+wndData.currentCol['id'],doc_print)
        else if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            let item={...d.data,type:'docReject'}
            item.table=d.table.map(el=>{return{...el}})
            tabNew('docPrint',localestr('Повернення'),item)
        }
    }

    const grpEdit=()=>{
        let list=[...wndData.list||[]]
        list=list.filter(el=>filter_fn(el,wndData.filter))
        list=list.map(el=>{return{...el,obj_type:'docReject',checked:true}})
        tabNew('serv_grp_doc',localestr('Групова обробка документів'),{list,checked:true,oper:1})
    }
        
    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newItem()
        else if(key==='F9') copyItem()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filter()
    }

    const needFocus=(reset=true)=>{   //Таблиця
        if(isActive()===false) return -1
        const glData=getGlData()
        const needFocus=glData.needFocus
        if(needFocus===undefined) return -1
        if(reset) setGlData({needFocus:-1})
        return needFocus
    }

    useEffect(() => {
        //console.log('effect1')
        if (typeof table === 'undefined') loadData()
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('date','asc',undefined)
    // eslint-disable-next-line 
    },[table])

    useEffect(() => {
        //console.log('effect2')
        const intervalHandle=setInterval(tick,30000)
        return () => clearInterval(intervalHandle)
    // eslint-disable-next-line 
    },[])

    const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter}/> : ''  //+
    //const showRange = wndData.showRange ? <RangeForm from={from} to={to} setRng={range}/> : ''  //+

    const menuData=[
        {name:localestr('Налаштування таблиці'),icon:'#b953',action:setHidenCols},
        {name:localestr('Фільтр'),icon:'#b955',action:filter},
        {name:localestr('Друк списку'),icon:'#b503',action:()=>{window.print()}},
        {name:localestr('Історія змін'),icon:'#b505',action:objHistory},
        {name:localestr('Проводки документа'),icon:'#postBut',action:objEntries},
        {name:localestr('Остаточне видалення'),icon:'#remBut',action:clrDocument},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{loadData()}},
        {name:localestr('Групова обробка'),icon:'#hisBut',action:grpEdit},
        //{name:localestr('Звіт 2'),action:()=>{},parent:1},
        //{name:localestr('Налаштування'),action:()=>{}}
    ]
    const menuDocs=[]
    if(choice) menuData.splice(2,4)
    if(choice) menuData.splice(3,1)
    if(!choice&&wndData.currentCol&&wndData.currentCol.docs){
        menuData.push({name:localestr('Підпорядковані документи'),icon:'#b952',isFolder:true,id:1})
        wndData.currentCol.docs.forEach(doc=>{
            let ic='#docum'
            if(doc.marked) ic+='Del'
            if(doc.posted) ic+='Pst'
            const fn=()=>load('action='+doc.obj_type+'&data='+doc.id,(d)=>{
                const status=d.status
                if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
                if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
                tabNew(doc.obj_type+'_edit',itemToText(doc),{...d.data,table:d.table})})
            menuData.push({name:itemToText(doc)+' '+doc.sum,icon:ic,parent:1,action:fn})
            menuDocs.push({name:itemToText(doc)+' '+doc.sum,icon:ic,action:fn})
        })
    }

    const inputData=[
        {name:localestr('Прихід'),icon:'#docum',action:()=>{inputItem('docSupply')}},
        {name:localestr('Ордер (поступлення від постач.)'),icon:'#docum',action:()=>{inputItem('docStatement')}},
    ]

    let btn1=null
    //let btn2=null
    if (wndData.currentCol){
        if(wndData.currentCol.posted==='1' || wndData.currentCol.posted===1) {
            btn1=<div  tabIndex='0' className='toolBarItem' title={localestr('Відмінити проведення')} 
            onClick={()=>unpostItem()}
            onKeyUp={(e)=>{if(e.key === 'Enter') unpostItem()}}><img src={icon+'#unpBut'} alt={localestr('Відмінити проведення')} /></div>  
            /*btn2=<div  tabIndex='0' className='toolBarItem' title={localestr('Друк')} 
            onClick={()=>window.print()}
            onKeyUp={(e)=>{if(e.key === 'Enter') window.print()}}><img src={icon+'#prnBut'} alt={localestr('Друк')} /></div>  
            */
        }
        else if(wndData.currentCol.marked!=='1' && wndData.currentCol.marked!==1) {
            btn1=<div  tabIndex='0' className='toolBarItem' title={localestr('Провести')} 
            onClick={()=>postItem()}
            onKeyUp={(e)=>{if(e.key === 'Enter') postItem()}}><img src={icon+'#pstBut'} alt={localestr('Провести')} /></div>  
        }
    }

    let btn2=null
    if(!choice&&wndData.currentCol&&wndData.currentCol.docs) btn2=<div tabIndex='0' className='toolBarItem' title={localestr('Підпорядковані документи')} >
    <Menu data={menuDocs}><img src={icon+'#unfoldBut'} alt={localestr('Підпорядковані документи')} /></Menu></div>
    
    return(
        <>
        <div className='print' style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={()=>newItem()}
            onKeyUp={(e)=>{if(e.key === 'Enter') newItem()}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Редагувати')} 
            onClick={()=>editItem()}
            onKeyUp={(e)=>{if(e.key === 'Enter') editItem()}}><img src={icon+'#editBut'} alt={localestr('Редагувати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
            onClick={()=>copyItem()} onKeyUp={(e)=>{if(e.key === 'Enter') copyItem()}}
            ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={()=>removeItem()}
            onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            {btn1}
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div tabIndex='0' onClick={()=>{inputRange(from,to,range)}} onKeyUp={(e)=>{if(e.key === 'Enter') inputRange(from,to,range)}}
                style={{textAlign:'center',lineHeight:'30px',height:'30px',width:'192px',padding:'0px 20px 0 2px',userSelect:'none',cursor:'pointer',color:'#FFF',background:'url('+icon+'#btn185v) no-repeat',backgroundSize:'192px 30px',boxSizing:'border-box',position:'relative',wordBreak:'break-all'}}>
                {strPeriod(from,to)}
                <img style={{width:'24px',height:'24px',position:'absolute',top:'5px',right:'4px'}} src={icon+'#cal_w'} alt={localestr('Інтервал дат')} />
            </div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}  
            onClick={()=>showHideFilter()}
            onKeyUp={(e)=>{if(e.key === 'Enter') showHideFilter()}}><img src={icon+'#filtBut'} alt={localestr('Автофільтр')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Ввести на підставі')}><Menu left={true} data={inputData}>
                <img className='toolBarIcon' src={icon+'#inpBut'} alt='' /></Menu></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Друк')}  
            onClick={()=>doc_print()}
            onKeyUp={(e)=>{if(e.key === 'Enter') doc_print()}}><img src={icon+'#prnBut'} alt={localestr('Друк')} /></div>
            {btn2}
            <div style={{flexGrow:'10'}}></div>
            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={wndData.currentCol} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={editClick} keyHandle={anyKey} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus}/>
        </div>
        {showFilter}
        {/*showRange*/}
        </>
    )
    
}

export default DocRejectList